import RequestAbstract from "../abstract";

export default class PayoutEvents extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payout-events";
    }

}
